G.BoardToken = function(layer, config, cellX, cellY, hp) {
  Phaser.Image.call(this, game, 
    layer.board.cellXToPxIn(cellX),
    layer.board.cellYToPxIn(cellY)
  );
  this.board = layer.board;
  this.config = config;
  this.anchor.setTo(0.5);

  this.layer = layer;
  this.layerGrid = layer.grid;

  this.cellX = cellX;
  this.cellY = cellY;
  this.hp = parseInt(hp);

};

G.BoardToken.prototype = Object.create(Phaser.Image.prototype);

G.BoardToken.prototype.onMatch = function() {

};

G.BoardToken.prototype.onHit = function() {

};

G.BoardToken.prototype.onBooster = function() {
  return false;
};

G.BoardToken.prototype.remove = function() {
  this.layer.removeToken(this.cellX, this.cellY);
};

G.BoardToken.prototype.deathAnimation = function() {
  this.destroy();
};